// extracted by mini-css-extract-plugin
export var alignRight = "footer-module--alignRight--c7557";
export var bureauweb = "footer-module--bureauweb--27052";
export var footer = "footer-module--footer--2b3fb";
export var grid = "footer-module--grid--db6e6";
export var legal = "footer-module--legal--16c02";
export var line = "footer-module--line--c1c21";
export var navLink = "footer-module--navLink--ffdc5";
export var navText = "footer-module--navText--fc3e2";
export var navTitle = "footer-module--navTitle--4d9fd";
export var navgrid = "footer-module--navgrid--ff849";
export var socialNetwork = "footer-module--socialNetwork--f53bc";